import { RichText, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import { Button } from '../Custom/Button';

type PrinciplesProps = ComponentProps & {
  fields: {
    title: {
      value: string
    },
    RequestDateButtonText:{
      value:string
    }
    GroupOfDataButtonText:{
      value:string
    }
    childItems: any[]
  };
  locale: string,
  lang: string
};
const Principles = (props: PrinciplesProps): JSX.Element => {
  return(
    <div className={`responsive md:py-20 py-10 ${props?.locale=="ar"?'rtl':''}`}>
        <h1 className="text-[28px] text-[#003141] font-bold animate-top-dga">{props.fields.title.value}</h1>
        <div className='grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 mt-8 '>
          {props.fields?.childItems?.slice(1).map((principle: any,index:number)=>{
            return(
              <div className='col-span-1 flex flex-col gap-4 p-8 bg-[#F2F2F2] animate-top-dga' key={index}>
<div className={`w-[44px] h-[8px] `} style={{background:principle?.fields?.TileColor?.value?principle?.fields?.TileColor?.value:''}}></div>
                <h3 className='text-[#2E2E2E] text-[18px] font-medium'>{principle?.fields?.Title?.value}</h3>
              <RichText className="text-[16px] text-[#5E5E5EFC]" field={principle?.fields?.Description}></RichText>
                </div>
            )
          })}
        </div>
        <div className='flex md:flex-row flex-col md:items-start items-center gap-4 mt-10'>
        <Button
            classNames="bg-[#062A30] !border-none text-white"
            redirect={props?.fields?.childItems[0].fields?.RequestDateButtonLink?.value.href}
            target={props?.fields?.childItems[0].fields?.RequestDateButtonLink?.value.target}
            text={props?.fields?.childItems[0].fields?.RequestDateButtonText?.value}
            linktype={props?.fields?.childItems[0].fields?.RequestDateButtonLink?.value.linktype}
          />
            <Button
            classNames="bg-[#062A30] !border-none text-white"
            redirect={props?.fields?.childItems[0].fields?.GroupOfDataButtonLink?.value.href}
            target={props?.fields?.childItems[0].fields?.GroupOfDataButtonLink?.value.target}
            text={props?.fields?.childItems[0].fields?.GroupOfDataButtonText?.value}
            linktype={props?.fields?.childItems[0].fields?.GroupOfDataButtonLink?.value.linktype}
          />
        </div>
    </div>
  );
}

export default withDatasourceCheck()<PrinciplesProps>(Principles);
